import { Icon } from "./icons.tsx"

export type StepState = "done" | "current" | "todo"
export type Step = { id: string; label: string; state: StepState }

/**
 * 진행 단계. 서버의 상태 머신을 눈에 보이게 한다.
 *
 * 좁은 화면에서는 동그라미만 남기고 현재 단계 이름만 아래 한 줄로 보여 준다.
 */
export function Stepper({ steps, ariaLabel }: { steps: Step[]; ariaLabel: string }) {
  const current = steps.find((step) => step.state === "current")
  return (
    <nav className="stepper" aria-label={ariaLabel}>
      <ol className="stepper__list">
        {steps.map((step, index) => (
          <li
            key={step.id}
            className={`stepper__step stepper__step--${step.state}`}
            aria-current={step.state === "current" ? "step" : undefined}
          >
            <span className="stepper__mark">
              {step.state === "done" ? <Icon name="check" size={13} /> : index + 1}
            </span>
            <span className="stepper__label">{step.label}</span>
          </li>
        ))}
      </ol>
      {current ? <p className="stepper__current">{current.label}</p> : null}
    </nav>
  )
}
